/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Footnote_ProviderInputs */

const en_admin_funnel_footnote_provider = /** @type {(inputs: Admin_Funnel_Footnote_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider table is by order creation time: payment success = orders paid ÷ orders created (abandoned checkouts count as unpaid).`)
};

/**
* | output |
* | --- |
* | "Provider table is by order creation time: payment success = orders paid ÷ orders created (abandoned checkouts count as unpaid)." |
*
* @param {Admin_Funnel_Footnote_ProviderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_footnote_provider = /** @type {((inputs?: Admin_Funnel_Footnote_ProviderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Footnote_ProviderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_footnote_provider(inputs)
});
export { admin_funnel_footnote_provider as "admin.funnel.footnote.provider" }